const langInvestWordLang = {
	nc: {
		tag: 'invest.word.nc',
		fr: 'n.c.',
		en: 'n.c.',
	},
	na: {
		tag: 'invest.word.na',
		fr: 'n/a',
		en: 'n/a',
	},
	ns: {
		tag: 'invest.word.ns',
		fr: 'n.s.',
		en: 'n.s.',
	},
	committed: {
		tag: 'invest.word.committed',
		fr: 'engagés',
		en: 'committed',
	},
	called: {
		tag: 'invest.word.called',
		fr: 'appelés',
		en: 'called',
	},
	estimated: {
		tag: 'invest.word.estimated',
		fr: 'Estimée',
		en: 'Estimated',
	},
	audited: {
		tag: 'invest.word.audited',
		fr: 'Auditées',
		en: 'Audited',
	},
	liquidated: {
		tag: 'invest.word.liquidated',
		fr: 'Liquidation',
		en: 'Liquidated',
	},
	date_at: {
		tag: 'invest.word.date_at',
		fr: 'à',
		en: 'at',
	},
	data_estimated_on: {
		tag: 'invest.word.data_estimated_on',
		fr: 'Données estimées le ',
		en: 'Data estimated on ',
	},
	data_audited_on: {
		tag: 'invest.word.data_audited_on',
		fr: 'Données auditées le ',
		en: 'Data audited on ',
	},
	data_updated_on: {
		tag: 'invest.word.data_updated_on',
		fr: 'Données mises à jour le ',
		en: 'Data updated on ',
	},
	all_funds: {
		tag: 'invest.word.all_funds',
		fr: 'Tous les fonds',
		en: 'All funds',
	},
	realized_funds: {
		tag: 'invest.word.realized_funds',
		fr: 'Fonds liquidés',
		en: 'Only realized funds',
	},
	unrealized_funds: {
		tag: 'invest.word.unrealized_funds',
		fr: 'Fonds non liquidés',
		en: 'Only unrealized funds',
	},
	rounding_k: {
		tag: 'invest.word.rounding_k',
		fr: 'Milliers',
		en: 'Thousands',
	},
	rounding_m: {
		tag: 'invest.word.rounding_m',
		fr: 'Millions',
		en: 'Millions',
	},
	rounding_b: {
		tag: 'invest.word.rounding_b',
		fr: 'Milliards',
		en: 'Billions',
	},
	x_words: {
		tag: 'invest.word.x_words',
		fr: '{{count}} mots',
		en: '{{count}} mots',
		plurals: {
			zero: {
				fr: 'Aucun mot',
				en: 'No word',
			},
			one: {
				fr: '{{count}} mot',
				en: '{{count}} word',
			},
			other: {
				fr: '{{count}} mots',
				en: '{{count}} words',
			},
		},
	},
};

export default langInvestWordLang;
